export type RecordsCounter =
  | { type: CounterTypes.counter; counter: number }
  | { type: CounterTypes.none };

export enum CounterTypes {
  none = 'none',
  counter = 'counter',
}
